var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNanciaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.343 52.022c-2.7219-0.05516-5.4679 0.2652-8.229 0.92432-10.265 4.5914-19.603 20.272-22.506 31.333-12.768 11.901-19.159 18.767-21.509 37.489 10.424-12.632 31.783-17.455 31.783-17.455 20.918-4.3878 26.191 16.591 26.784 36.649-2.3e-4 18.578-15.595 39.511-31.728 39.512-13.02-0.0746-24.62-23.151-26.39-30.366 12.132 55.468 30.099 57.219 64.116 57.317 34.017 0.0976 60.637-41.296 60.536-76.669-0.88256-35.747-9.8441-47.405-30.524-60.286 5.6025 1.0354 10.858 3.7928 15.214 7.9814-12.117-13.559-28.33-21.174-45.226-21.241-4.4124 0.06352-8.8077 0.64253-13.119 1.7281 4.4329-1.1524 9.7461-3.6928 14.168-3.3406-4.3645-2.3487-8.8347-3.4836-13.371-3.5756zm1.3961 25.283c-11.093 3.8737-5.0517 7.9365-18.417 10.698 0.82957-11.492 14.938-12.652 18.417-10.698z",
    fill: "#002755",
    strokeWidth: 13.888
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.52 41.376c-7.7166 19.001-69.938 97.508-119.93 77.201-6.2382-3.3178 13.867-17.46 13.867-17.46s-16.102 14.167-9.9678 15.931c49.96 14.366 104.21-60.579 116.03-75.672z",
    fill: "#00d2d2",
    strokeWidth: 7.9375
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNanciaLogo);
export default __webpack_public_path__ + "static/media/nancia-logo.9371d52d2539bf00b0cd7c538616835f.svg";
export { ForwardRef as ReactComponent };